module.exports = __webpack_public_path__ + "img/KRT.3d8937fc.png";